import { Injectable } from "@angular/core";
import { DocumentSectionComponent } from "../../tutor-reports/tutor-report-timeline/timeline-sections/document-section/document-section.component";
import { ProgressSectionComponent } from "../../tutor-reports/tutor-report-timeline/timeline-sections/progress-section/progress-section.component";
import { MilestoneSectionComponent } from "../../tutor-reports/tutor-report-timeline/timeline-sections/milestone-section/milestone-section.component";
import { ObservationSectionComponent } from "../../tutor-reports/tutor-report-timeline/timeline-sections/observation-section/observation-section.component";
import { TargetsSectionComponent } from "../../tutor-reports/tutor-report-timeline/timeline-sections/targets-section/targets-section.component";
import { ClassicProgressSectionComponent } from "../../tutor-reports/tutor-report-timeline/timeline-sections/classic-progress-section/classic-progress-section.component";
import { ClassicSessionSectionComponent } from "../../tutor-reports/tutor-report-timeline/timeline-sections/classic-session-section/classic-session-section.component";
import { LeapV2IlpSectionComponent } from "../../tutor-reports/tutor-report-timeline/timeline-sections/leap-v2-ilp-section/leap-v2-ilp-section.component";
import { LeapV2ProgressReportSectionComponent } from "../../tutor-reports/tutor-report-timeline/timeline-sections/leap-v2-progress-report-section/leap-v2-progress-report-section.component";
import { LeapV2SessionSectionComponent } from "../../tutor-reports/tutor-report-timeline/timeline-sections/leap-v2-session-section/leap-v2-session-section.component";
import { MilestoneEventSectionComponent } from "../../tutor-reports/tutor-report-timeline/timeline-sections/milestone-event-section/milestone-event-section.component";

@Injectable({ providedIn: 'root' })
export class LearningSectionRendererHelperService {
  private learningSections: any[] = [
    { type: "milestone", component: MilestoneSectionComponent },
    { type: "milestone-event", component: MilestoneEventSectionComponent },
    { type: "document", component: DocumentSectionComponent },
    { type: "observation", component: ObservationSectionComponent },
    { type: "progress", component: ProgressSectionComponent },
    { type: "target", component: TargetsSectionComponent },
    { type: "session", component: LeapV2SessionSectionComponent },

    { type: "classic-session", component: ClassicSessionSectionComponent },
    { type: "classic-progress", component: ClassicProgressSectionComponent },
    { type: "classic-ilp", component: LeapV2IlpSectionComponent },
    { type: "progress-report", component: LeapV2ProgressReportSectionComponent },
  ];

  public getLearningSection(type) {
    return this.learningSections.find((section) => {
      return section.type === type;
    });
  }
}
